export default __webpack_public_path__ + "static/media/chevron.ccc219ae.svg";